module.exports = __webpack_public_path__ + "static/media/textcontaing.8adb4418.png";